import {
  OrbitControls,
  PerspectiveCamera,
  Sky,
  Sparkles,
  Stars,
} from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import React, { useContext } from "react";
import CameraController from "./CameraController";
import Landscape from "./Landscape";
import MusicNodeManager from "./MusicNodeManager";
import Player from "./Player";
import {
  EffectComposer,
  Bloom,
  Noise,
  Vignette,
  BrightnessContrast,
} from "@react-three/postprocessing";
import { AppContext } from "./App";

export default function ThreeManager() {
  const { highGraphics } = useContext(AppContext);
  return (
    <Canvas
      onCreated={({ gl }: any) => {
        gl.setClearColor("#222222");
      }}
      //shadows
    >
      <Landscape />
      <Player />
      <MusicNodeManager />
      <CameraController />
      {/* <OrbitControls /> */}
      {highGraphics && (
        <EffectComposer>
          <Noise opacity={0.03} />
          <Vignette eskil={false} offset={0.1} darkness={1.2} />
          <BrightnessContrast contrast={0.15} />
        </EffectComposer>
      )}
    </Canvas>
  );
}
